import { create } from "zustand";

const initialState = {
  openSidebar: false,
  currentPage: null,
};

const useNavigationStore = create((set) => ({
  ...initialState,
  toggleSidebar: () => {
    set((state) => ({ openSidebar: !state.openSidebar }));
  },
  setOpenSidebar: (payload) => {
    set({ openSidebar: payload });
  },
  setCurrentPage: (payload) => {
    set({ currentPage: payload });
  },
}));

export default useNavigationStore;
